import React from "react";
import { useState } from "react";
import '../HomePage/Quotes.css';
import '../HomePage/HomeInsurance.css';
import { CommaSeprator } from "./UtilityComponents/UilityFunctions";

const ProposalFormDetail = ({ QuoteReq, QuoteRes }) => {
    
    return (
        <>
            <div className="Form_detail proposal_formdetail">
                
                <ul className="detail1 mb-0 p-0 text-center">
                    {(QuoteReq.propertyType === "BUILDING" || QuoteReq.propertyType === "Both") && <><li className="area_detail">
                        <small>Building Area</small>
                        <p><b>{CommaSeprator(QuoteReq.BuildingComponent?.areaOfBuilding)}</b></p>
                    </li>
                    <li className="area_detail2">
                            <small>Rate per sq.ft</small>
                            <p><b>₹{CommaSeprator(Math.round(parseInt(QuoteReq.BuildingComponent?.valueOfBuilding) / parseInt(QuoteReq.BuildingComponent?.areaOfBuilding)))}</b></p>
                    </li>
                    <li className="area_detail1">
                        <small>Value of building</small>

                            <p><b>₹{CommaSeprator(QuoteReq.BuildingComponent?.valueOfBuilding)}</b></p>
                        </li></>}
                    {(QuoteReq.propertyType === "HOUSEHOLD" || QuoteReq.propertyType === "Both") && <li className="area_detail area_detail3">
                        <small>Value of HouseHold Item</small>
                        <p><b>₹{CommaSeprator(QuoteReq.BuildingComponent?.valueOfHouseHoldItem)}</b></p>
                    </li>}
                    <li className="area_detail2">
                        <div className="policy_term22">
                            <span className="d-block mt-2">Policy Term</span>
                            <p><b>{CommaSeprator(QuoteRes.policyTerm)}</b></p>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}
export default ProposalFormDetail;